import React, { useEffect } from "react";
import CardForms from "../../components/Card/CardForms";
import Grid from "@material-ui/core/Grid";
import SearchDevelopment from "../../components/Desarrollo/SearchDevelopment";
import SelectBlocks from "../../components/Manzanas/SelectBlocks";
import LotGrid from "../../components/Lotes/LotGrid";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";

const AssignLot = ({
  getLots,
  idBlock,
  developments,
  getBlocks,
  onChangeBlock,
  onChangeLot,
  blocks,
  lot,
  idLot
}) => {
  useEffect(() => {
    if (idBlock > 0) getLots(idBlock, false);
  }, [idBlock]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <CardForms title="Seleccionar lote">
      <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
        Selecciona el desarrollo, la manzana y el lote disponible para el contrato
      </Typography>
      <Grid container spacing={3} alignItems="flex-end">
        <Grid item xs={12} sm={4} md={3}>
          <SearchDevelopment
            developments={developments}
            onChange={getBlocks}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <SelectBlocks
            onChange={onChangeBlock}
            blocks={blocks}
            idBlock={idBlock}
          />
        </Grid>
      </Grid>

      {idBlock > 0 && (
        <LotGrid
          lots={lot}
          selectedLotId={idLot}
          onSelectLot={onChangeLot}
        />
      )}
    </CardForms>
  );
};

AssignLot.propTypes = {
  getLots: PropTypes.func,
  idBlock: PropTypes.number,
  developments: PropTypes.array,
  getBlocks: PropTypes.func,
  onChangeBlock: PropTypes.func,
  onChangeLot: PropTypes.func,
  blocks: PropTypes.array,
  lot: PropTypes.array,
  idLot: PropTypes.number
};

export default AssignLot;
